module.exports = __webpack_public_path__ + "img/wordpress-banner.37eef5c7.webp";